import React from 'react';
var SRC = 'https://static.wixstatic.com/media/5e9922_0a9111966d7648649336e1f1546c5ec9~mv2.gif';
export function BlankImage(_a) {
    var _b = _a.className, className = _b === void 0 ? 'blank-image' : _b, width = _a.width, _c = _a.height, height = _c === void 0 ? 1 : _c, _d = _a.alt, alt = _d === void 0 ? '' : _d;
    return (React.createElement("img", { className: className, src: SRC, width: width, height: height, style: { border: '0px' }, alt: alt }));
}
//# sourceMappingURL=blank-image.js.map